import usePaging from "../../../hooks/usePaging";
import { useLocation } from "react-router-dom";
import { useGetFeaturesQuery } from "../featuresSlice";
import useRefresher from "../../../hooks/useRefresher";

const useFeatures = () => {
  const location = useLocation();
  const { activePage } = usePaging({});
  const features = useGetFeaturesQuery({
    page: location.pathname.startsWith("/features") ? activePage : 1,
  });
  useRefresher(features);

  return {
    ...features,
    data: features?.data?.response,
    pagination: features?.data?.pagination,
  };
};

export default useFeatures;
